import Head from "next/head"
import React from "react"

export const HelmetTitle = ({ title, hide = false }) => (
  <Head>
    <title>{`${title}${hide ? "" : " | Discover ArtPlacer"}`}</title>
  </Head>
)
